export default __webpack_public_path__ + "static/media/access-denied.e357e274.svg";